import { AxiosError, AxiosResponse } from "axios";
import { DataType, FieldType } from "@websential/cosmic-v20";
import { IGetListRequest, IResponse, IServerError } from "../models/common";

import { GridSize } from "@mui/material";
import { IClient } from "../models";
import { format422Errors } from "../common/Common";
import http from "../common/http-commons";

// import { IFixedAndMetaField } from 'common/FlexFieldsUtils';

// import { IVendorListPayload, IVendorRequest, IVendorResponse } from 'models/vendor';
// import { CLIENT_SETUP_FORM, CLIENT_SETUP_FORM_FOR_ADMIN_USER } from 'screensLayoutData/client';

// import { IAPIKeysRequest, IAPIKeysResponse } from '../models';

// import { IEmployeeListPayload, IEmployeeRequest, IEmployeeResponse } from '../models/employee';

// import { INITIAL_PAGE_SIZE } from 'common/constants';

export const ClientService = {
  // generate: async (
  //   data: IAPIKeysRequest
  // ): Promise<IAPIKeysRequest | IAPIKeysResponse | IServerError | IResponse> => {
  //   const response: AxiosResponse<IAPIKeysRequest> = await http.post<IAPIKeysRequest>(
  //     "/accounts/client/api/keys/",
  //     data
  //   );
  //   if (response.status === 200) return response.data;
  //   else if (response.status === 400) {
  //     return {
  //       status: false,
  //       message: "Bad Request.",
  //       error: true,
  //     };
  //   } else if (response.status === 500) {
  //     return {
  //       status: false,
  //       message: "Something went wrong.",
  //       error: true,
  //     };
  //   }
  //   return {
  //     status: false,
  //     message: "Something went wrong please try again later.",
  //   };
  // },
  // getEmployees: async (
  //   data: IEmployeeRequest
  // ): Promise<
  //   IEmployeeResponse | IEmployeeListPayload | IServerError | IResponse
  // > => {
  //   const response: AxiosResponse<IEmployeeListPayload> = await http.get<IEmployeeListPayload>(
  //     // TODO: update this url when employee api deployed
  //     // "accounts/master/data/setup/Employee/?client_ids=" + data.client_id
  //     "/v1/accountants/"
  //   );
  //   if (response.status === 200) return response.data;
  //   else if (response.status === 400) {
  //     return {
  //       status: false,
  //       message: "Bad Request.",
  //       error: true,
  //     };
  //   } else if (response.status === 500) {
  //     return {
  //       status: false,
  //       message: "Something went wrong.",
  //       error: true,
  //     };
  //   }
  //   return {
  //     status: false,
  //     message: "Something went wrong please try again later.",
  //   };
  // },
  // getVendors: async (
  //   data: IVendorRequest
  // ): Promise<
  //   IVendorResponse | IVendorListPayload | IServerError | IResponse
  // > => {
  //   const response: AxiosResponse<IVendorListPayload> = await http.get<IVendorListPayload>(
  //     // TODO: update this url when vendor api deployed
  //     // "accounts/master/data/setup/Vendor/?client_ids=" + data.client_id
  //     "/v1/accountants/"
  //   );
  //   if (response.status === 200) return response.data;
  //   else if (response.status === 400) {
  //     return {
  //       status: false,
  //       message: "Bad Request.",
  //       error: true,
  //     };
  //   } else if (response.status === 500) {
  //     return {
  //       status: false,
  //       message: "Something went wrong.",
  //       error: true,
  //     };
  //   }
  //   return {
  //     status: false,
  //     message: "Something went wrong please try again later.",
  //   };
  // },
  // getSetupLayout: async (isAdminUser:number): Promise<any> => {
  //   let response: any = isAdminUser !== 1 ? CLIENT_SETUP_FORM : CLIENT_SETUP_FORM_FOR_ADMIN_USER;
  //   return new Promise(resolve => setTimeout(() => resolve(response), 1000));
  // },
  simpleClientGetById: async (
    id: string | undefined,
  ): Promise<IClient | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<IClient> = await http.get<IClient>(
        `/v1/clients/${id}/`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return {
        status: false,
        message: errorMessage,
      };
    }
  },
  getById: async (
    id: string | undefined,
    navigateToLogout: (path: string) => void,
    isAdminUser?: number,
    superUserFieldsShownInClientSetup?: boolean,
    clientId?: string,
  ): Promise<IClient | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<IClient> = await http.get<IClient>(
        isAdminUser === 400 && superUserFieldsShownInClientSetup && !clientId
          ? `/v1/clients/${id}/`
          : `/v1/clients/${id}/`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getSimpleClientById: async (
    id: string | undefined,
    navigateToLogout: (path: string) => void,
  ): Promise<IClient | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<IClient> = await http.get<IClient>(
        `/v1/clients/${id}/`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getSimpleClientByIdForPayroll: async (
    id: string | undefined,
    navigateToLogout: (path: string) => void,
  ): Promise<IClient | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<IClient> = await http.get<IClient>(
        `/v1/clients/client_details_for_payroll/${id}/`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  create: async (
    requestPayload: any,
  ): Promise<IClient | IServerError | IResponse | any> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<IClient> = await http.put<IClient>(
          // `/v1/clients/${requestPayload.id}/`,
          requestPayload.isAdminUser === 400
            ? `/v1/clients/super-user/${requestPayload.id}/`
            : `/v1/clients/${requestPayload.id}/`,
          requestPayload,
        );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else if (axiosError && axiosError.status === 422) {
          return {
            status: false,
            message: `Errors : \n${format422Errors(
              axiosError?.response?.data,
            )}`,
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    try {
      const response: AxiosResponse<IClient> = await http.post<IClient>(
        // "/v1/clients/",
        requestPayload.isAdminUser === 400
          ? "/v1/clients/super-user"
          : "/v1/clients/",
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 422) {
        return {
          status: false,
          message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  deleteById: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
       		// `/v1/clients/${delPayload.clientBankId}/`,
				`/v1/clients/${delPayload.clientId}/`,
      );

      if (response.status === 204) {
        return "Client has been deleted successfully";
      } else if (response.status === 200) {
        return "Client has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  deleteClientBankById: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/client-bank/${delPayload.clientBankId}/`,
      );

      if (response.status === 204) {
        return "Client has been deleted successfully";
      } else if (response.status === 200) {
        return "Client has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  createClientBank: async (
    requestPayload: any,
  ): Promise<IClient | IServerError | IResponse | any> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<any> = await http.put<IClient>(
          `/v1/client-bank/${requestPayload.id}/`,
          requestPayload,
        );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 404) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    try {
      const response: AxiosResponse<any> = await http.post<IClient>(
        "/v1/client-bank/",
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 404) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getClientBankDataById: async (
    id: string | undefined,
    navigateToLogout: (path: string) => void,
  ): Promise<IClient | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<IClient> = await http.get<IClient>(
        `/v1/client-bank/${id}/`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getGetClientDDL: async (
    accountantId: string,
  ): Promise<any | IServerError | IResponse | null> => {
    if (!accountantId) return null;

    if (accountantId === "all") {
      try {
        const response: AxiosResponse<any[]> = await http.get<any[]>(
          `/v1/clients/full-ddl/list/`,
        );

        if (response.status === 200) {
          return response.data;
        }

        return {
          status: false,
          message: "Something went wrong please try again later.",
        };
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        return {
          status: false,
          message: errorMessage,
        };
      }
    } else {
      try {
        const response: AxiosResponse<any[]> = await http.get<any[]>(
          `/v1/clients/ddl?accountant_id=${accountantId}`,
        );

        if (response.status === 200) {
          return response.data;
        }

        return {
          status: false,
          message: "Something went wrong please try again later.",
        };
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getAllClientsDDL: async (): Promise<
    any | IServerError | IResponse | null
  > => {
    const response: AxiosResponse<any[]> =
      await http.get<any[]>(`/v1/clients/ddl`);

    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  getGetClientBankList: async (
    clientId: string,
    data: IGetListRequest,
    navigateToLogout: (path: string) => void,
  ): Promise<any | IServerError | IResponse | null> => {
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        "/v1/client-bank/?client_id=" +
          clientId +
          "&order_by=" +
          data.order_by +
          "&order_direction=" +
          data.order_direction +
          "&page=" +
          data.page +
          "&size=" +
          data.size +
          "&search_query=" +
          data.search_query,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getGetClientBankDDL: async (
    clientId: string,
  ): Promise<any | IServerError | IResponse | null> => {
    const response: AxiosResponse<any[]> = await http.get<any[]>(
      `/v1/client-bank/ddl?client_id=${clientId}`,
    );

    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  archiveClientBanks: async (
    archivePayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.post<string>(
        `/v1/client-bank/${archivePayload.departmentsId}/`,
      );

      if (response.status === 201) {
        return "Client Bank has been archived successfully";
      } else if (response.status === 200) {
        return "Client Bank has been archived successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        archivePayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
};
